import './Button.scss';

export default function Button({ text, subtext = null, children = null, onClick, style_, class_, selected = false }) {
    const classes = 'black-button ' + (class_ ? class_ : '') + (selected ? ' selected' : '');
    return (
        <div className={classes} onClick={onClick} style={style_}>
            {text}
            {subtext && <div className="button-subtext">{subtext}</div>}
            {children}
        </div>
    );
}